// Week 2 / Day 4 — Nimny's Help Plan: Emergency Situation.
// Reworked: bilingual RU/EN inline; calm, empowering tone.
// 50% online + 50% paper/parent. Five layers preserved.
// SAFETY: no real PII online — real address/phone are paper-only with parent.

const day4 = {
  id: 'day-4',
  studentId: 'max',
  weekId: 'week-2',
  dayId: 'day-4',
  status: 'active',
  title: 'План помощи Нимни: экстренная ситуация / Nimny\'s Help Plan: Emergency Situation',
  shortTitle: 'План помощи / Help Plan',
  theme:
    'В экстренной ситуации помогает заранее подготовленный план. / In an emergency, a prepared plan helps.',
  estimatedTimeLabel:
    'Онлайн-миссия: около 20–30 минут. Бумажная миссия с родителем: около 25–35 минут. / Online mission: about 20–30 minutes. Paper mission with parent: about 25–35 minutes.',
  nimnyIntro:
    'Нимни получила четвёртую часть Щита безопасности — план помощи. Он помогает не паниковать, а знать: где я, кому сказать и что делать первым. / Nimny received the fourth part of the Safety Shield — the help plan. It helps us not panic, but know: where I am, who to tell and what to do first.',
  goals: [
    'Слой 1. Математика: время, шаги плана и таблицы ситуаций. / Layer 1. Math: time, plan steps and situation tables.',
    'Слой 2. Русский язык и правописание: словарь помощи, мини-диктант, исправление. / Layer 2. Russian language and spelling: help vocabulary, mini-dictation, correction.',
    'Слой 3. Чтение, письмо и пересказ: «Что сказать, если нужна помощь?» — план, пересказ и 3–5 предложений. / Layer 3. Reading, writing and retelling: "What to say if you need help?" — plan, retell and 3–5 sentences.',
    'Слой 4. Наблюдение и логика — что делать первым. / Layer 4. Observation and Logic — What To Do First.',
    'Слой 5. Практика на бумаге: «Карточка помощи» с настоящими данными — только на бумаге и с родителем. / Layer 5. Paper practice: "Help Card" with real data — paper-only, with a parent.',
    'Дневник мышления: одна уверенная фраза экстренной помощи. / Thinking diary: one confident emergency phrase.',
    'Награда нимами: базово 3 нима, максимум 5 с бонусами. / Reward in nims: 3 base, up to 5 with bonuses.'
  ],
  vocabulary: [
    { term: 'экстренная ситуация / emergency', definition: 'когда нужна помощь сразу. / when help is needed right away.' },
    { term: 'помощь / help', definition: 'когда взрослый или служба помогают. / when an adult or service helps.' },
    { term: 'адрес / address', definition: 'где я нахожусь. Записываю только на бумаге с родителем. / where I am. Written only on paper with a parent.' },
    { term: 'телефон / phone', definition: 'номер, который мы знаем с родителем. / a number we know with a parent.' },
    { term: 'оператор / operator', definition: 'человек, который отвечает на 911. / the person who answers 911.' },
    { term: 'пожар / fire', definition: 'опасная ситуация, нужна экстренная помощь. / dangerous situation; emergency help needed.' },
    { term: 'потерялся / got lost', definition: 'не знаю, где я; ищу безопасного взрослого. / I do not know where I am; I find a safe adult.' },
    { term: 'безопасное место / safe place', definition: 'место, где можно ждать помощь. / a place where I can wait for help.' },
    { term: 'встреча / meeting place', definition: 'где мы с семьёй встречаемся. / where my family meets.' },
    { term: 'план / plan', definition: 'короткий список шагов. / a short list of steps.' }
  ],
  onlineTasks: [
    {
      id: 'q1',
      type: 'math',
      title: 'Масштаб школьной карты / School map scale',
      prompt:
        'Что сделать / What to do: найди реальное расстояние в метрах.\nНа карте школы 1 см означает 20 метров. От класса до офиса школы на карте 3.5 см. Сколько это метров в реальности?\nOn the school map, 1 cm means 20 meters. From the classroom to the school office is 3.5 cm on the map. How many meters is that in real life?',
      helper: 'Это задача на масштаб: длина на карте × значение масштаба. / Scale problem: map length × scale factor.',
      answer: '70',
      unit: 'метров / meters'
    },
    {
      id: 'q2',
      type: 'math',
      title: 'Скорость спокойного шага / Calm walking speed',
      prompt:
        'Что сделать / What to do: посчитай время пути в минутах.\nНимни идёт спокойным шагом со скоростью 60 метров в минуту. До безопасного места 180 метров. Сколько минут займёт путь?\nNimny walks calmly at 60 meters per minute. The safe place is 180 meters away. How many minutes will it take?',
      helper: 'Время = расстояние ÷ скорость. / Time = distance ÷ speed.',
      answer: '3',
      unit: 'минут / minutes'
    },
    {
      id: 'q3',
      type: 'math',
      title: 'Время плана помощи / Help plan time',
      prompt:
        'Что сделать / What to do: посчитай общее время плана в минутах.\nПлан помощи состоит из шагов: остановиться — 0.5 минуты, перейти в безопасное место — 1.25 минуты, найти взрослого — 2 минуты, объяснить ситуацию — 0.75 минуты. Сколько минут занимает весь план?\nThe help plan has steps: stop — 0.5 minutes, move to a safe place — 1.25 minutes, find an adult — 2 minutes, explain the situation — 0.75 minutes. How many minutes does the full plan take?',
      helper: 'Сложи десятичные числа; пары четвертей могут сложиться в целое. / Add decimals; pairs of quarters can combine into whole numbers.',
      answer: '4.5',
      unit: 'минут / minutes'
    },
    {
      id: 'q4',
      type: 'math',
      title: 'Координаты безопасного маршрута / Safe route coordinates',
      prompt:
        'Что сделать / What to do: посчитай длину маршрута в метрах.\nНа сетке класс находится в точке (2,7), офис — в точке (8,7), медкабинет — в точке (8,3), выход — в точке (11,3). Нимни идёт от класса в офис, потом в медкабинет, потом к выходу. Одна клетка = 5 метров. Сколько метров весь маршрут?\nOn a grid, the classroom is at (2,7), the office at (8,7), the nurse\'s room at (8,3), and the exit at (11,3). Nimny goes from classroom to office, then nurse\'s room, then exit. One grid step = 5 meters. How many meters is the full route?',
      helper: 'Считай шаги по сетке отдельно по горизонтали и вертикали, сложи, потом × 5. / Count grid steps (horizontal + vertical), add, then × 5.',
      answer: '65',
      unit: 'метров / meters'
    },
    {
      id: 'q5',
      type: 'classify',
      title: 'Слова помощи — правописание / Help words — spelling',
      prompt:
        'Какая безударная гласная в корне? Используй проверочное слово. / Which unstressed root vowel? Use a check word.',
      categories: [
        { id: 'o', label: 'пишем «о» / write "о"' },
        { id: 'a', label: 'пишем «а» / write "а"' },
        { id: 'e', label: 'пишем «е» / write "е"' }
      ],
      items: [
        { id: 'pomoshh', text: 'п_мощь — проверка: помощник / "pomoshh" — check: помощник' },
        { id: 'telefon', text: 'т_лефон — проверка: телефонный / "telefon" — check: телефонный' },
        { id: 'ad_res', text: '_дрес — запомнить (словарное) / "address" — memorise' },
        { id: 'pl_n', text: 'пл_н — проверка: плановый / "plan" — check: плановый' },
        { id: 'mest', text: 'м_сто — проверка: место / "mesto" — check: место' },
        { id: 'op_rator', text: 'оп_ратор — запомнить / "operator" — memorise' }
      ]
    },
    {
      id: 'q6',
      type: 'text',
      title: 'Мини-диктант / Mini-dictation',
      prompt:
        'Запиши без ошибок: «В экстренной ситуации важно сказать, где ты находишься, и попросить помощь. Личные данные записывают только с родителем.» / Write without mistakes: "In an emergency it is important to say where you are and ask for help. Personal information is written only with a parent."',
      placeholder:
        'В экстренной ситуации ... / In an emergency ...'
    },
    {
      id: 'q_corr',
      type: 'text',
      title: 'Исправь ошибки / Correct the mistakes',
      prompt:
        'Перепиши без ошибок: «в экстреной ситуации важна сказат где ты находишся и пасросить помощь. личные даные записываит толька с радителем.» Подсказки: безударные гласные проверяй ударением; «экстренной», «данные» — две «н»; «сказать», «находишься» — мягкий знак; запятая перед «и» в сложном перечислении сохраняется. / Rewrite: fix unstressed vowels; double "н" in «экстренной», «данные»; soft sign in «сказать», «находишься»; capital letters.',
      placeholder:
        'В экстренной ситуации важно сказать, где ты находишься, и попросить помощь. Личные данные записывают только с родителем. / In an emergency ...'
    },
    {
      id: 'q7',
      type: 'text',
      title: 'План текста и письмо / Text plan and writing',
      prompt:
        'Прочитай короткий текст: «В экстренной ситуации скажи имя (если нужно), где ты, что случилось, и слушай взрослого или оператора. Никогда не звони 911 ради игры. Личные данные пиши только на бумаге с родителем.» Запиши план из 3 пунктов и 3–5 предложений на русском по теме: «Что я скажу, если мне нужна помощь?» / Read the short text: "In an emergency, say your name (if needed), where you are, what happened, and listen to the adult or operator. Never call 911 as a game. Write personal information only on paper with a parent." Write a 3-point plan and 3–5 Russian sentences on: "What will I say if I need help?"',
      placeholder:
        '1. ... 2. ... 3. ... Мои предложения: ... / 1. ... 2. ... 3. ... My sentences: ...'
    },
    {
      id: 'q_obs',
      type: 'text',
      title: 'Наблюдение и логика — что делать первым / Observation and Logic — What To Do First',
      prompt:
        'Реши коротко:\nЧто важно сделать первым? ____\nЧто меняется, если я просто паникую? ____\nЧто остаётся одинаковым в плане каждый раз? ____\nГде можно безопасно ждать помощь? ____\nЧто я скажу по телефону, если 911 (или 102/103 — спроси у родителя)? ____\nСделай вывод одной фразой. Личные данные НЕ пиши онлайн. / Decide briefly: first action; effect of panic; what stays the same; where to wait; what to say to 911. One-line conclusion. No PII online.',
      placeholder:
        'Первое: ... Если паникую: ... Одинаково: ... Где ждать: ... 911: ... Вывод: ... / First: ... Panic: ... Same: ... Wait: ... 911: ... Conclusion: ...'
    },
    {
      id: 'q8',
      type: 'classify',
      title: 'Экстренная или нет / Emergency or not',
      prompt:
        'Распредели карточки по 3 корзинам действий. / Sort cards into 3 action baskets.',
      categories: [
        { id: 'em', label: 'Экстренная — позвать взрослого/911 / Emergency — adult/911' },
        { id: 'nem', label: 'Не экстренная — спокойно / Not emergency — calm' },
        { id: 'ask', label: 'Спросить взрослого / Ask an adult' }
      ],
      items: [
        { id: 'fire', text: 'дым или пожар дома / smoke or fire at home' },
        { id: 'cuthand', text: 'сильно поранил руку / a bad cut on my hand' },
        { id: 'lostmall', text: 'потерялся в магазине / got lost in a store' },
        { id: 'forgothw', text: 'забыл домашку / forgot homework' },
        { id: 'argue', text: 'поспорил с другом / argued with a friend' },
        { id: 'feeloff', text: 'чувствую себя странно и тревожно / feel strange and anxious' },
        { id: 'someonehurt', text: 'кому-то рядом плохо / someone nearby is hurt' },
        { id: 'lostway', text: 'не помню дорогу домой / cannot remember the way home' }
      ]
    },
    {
      id: 'q9',
      type: 'essay',
      title: 'Дневник мышления: моя фраза экстренной помощи / Thinking diary: my emergency phrase',
      prompt:
        'Напиши 3–5 предложений: что я скажу, если мне нужна срочная помощь, и кому. Используй слова: помощь, безопасное место, взрослый. На английском добавь одну фразу: "I need help" или "This is an emergency". Личные данные не пиши — только в бумажной карточке с родителем. / Write 3–5 sentences: what I will say if I need urgent help, and to whom. Use words: help, safe place, adult. Add one English phrase. Do NOT write real personal data here — paper card with parent only.',
      minSentences: 3,
      maxSentences: 5,
      placeholder:
        'Если мне нужна срочная помощь ... / If I need urgent help ...'
    }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 2, День 4 — План помощи Нимни». / Heading: "Week 2, Day 4 — Nimny\'s Help Plan".',
    'Слой 1. Математика: реши q1–q4 и нарисуй полосу 4 типов ситуаций (5/4/3/3). / Layer 1. Math: solve q1–q4 and draw a 4-bar chart.',
    'Слой 2. Русский язык: запиши словарь помощи и мини-диктант. / Layer 2. Russian: write the help vocabulary and the mini-dictation.',
    'Слой 3. Чтение и пересказ: 3-пунктовый план + 3–5 предложений; перескажи родителю. / Layer 3. Reading and retelling.',
    'Слой 4. Наблюдение и логика: запиши порядок шагов: стоп → дыши → найди взрослого → 911 если экстренно → скажи где ты. / Layer 4. Observation and Logic: write the action order.',
    'Слой 5. Практика: заполни бумажную карточку помощи с родителем. / Layer 5. Practice: fill the paper Help Card with a parent.',
    'Дневник мышления: одна уверенная фраза экстренной помощи. / Thinking diary: one confident emergency phrase.',
    'Награда нимами начисляется после проверки родителем. / Reward in nims is added after a parent check.'
  ],
  printWorksheet: {
    title: 'Неделя 2, День 4 / Week 2, Day 4',
    subtitle: 'План помощи Нимни / Nimny\'s Help Plan',
    pages: [
      {
        title: 'Маршрут миссии — План помощи Нимни / Mission Route — Nimny\'s Help Plan',
        blocks: [
          { type: 'text', text: 'Сегодня — пять слоёв и одна миссия. Отмечай ☐ → ☑. / Today — five layers and one mission. Mark ☐ → ☑.' },
          { type: 'list', items: [
            '☐ Слой 1. Математика — около 10 минут. / Layer 1. Math — about 10 minutes.',
            '☐ Слой 2. Русский язык — около 10 минут. / Layer 2. Russian — about 10 minutes.',
            '☐ Слой 3. Чтение и пересказ — около 10 минут. / Layer 3. Reading and retelling — about 10 minutes.',
            '☐ Слой 4. Наблюдение и логика — около 5 минут. / Layer 4. Observation and Logic — about 5 minutes.',
            '☐ Слой 5. Практика на бумаге — около 15 минут. / Layer 5. Paper practice — about 15 minutes.',
            '☐ Дневник мышления — 5 минут. / Thinking diary — 5 minutes.',
            '☐ Печать миссии и награда нимами. / Mission stamp and nim reward.'
          ]}
        ]
      },
      {
        title: 'Слой 1. Математика — план помощи в числах / Layer 1. Math — Help Plan in Numbers',
        blocks: [
          { type: 'text', text: 'Математика уровня 5–6 класса. Запиши решение по шагам и финальный ответ. / Grade 5–6 math. Show steps and the final answer.' },
          { type: 'list', items: [
            '1) На карте 1 см = 20 м. От класса до офиса 3.5 см. Сколько это метров? Ответ: ____ м / 1 cm = 20 m; map distance 3.5 cm = ?',
            '   Шаги / Steps: __________________________________________',
            '2) Скорость 60 м/мин, расстояние 180 м. За сколько минут? Ответ: ____ мин / 180 ÷ 60 = ?',
            '   Шаги / Steps: __________________________________________',
            '3) План: 0.5 + 1.25 + 2 + 0.75 минуты. Всего минут? Ответ: ____ мин / Sum of decimal minutes',
            '   Шаги / Steps: __________________________________________',
            '4) Маршрут (2,7)→(8,7)→(8,3)→(11,3). Одна клетка = 5 м. Всего метров? Ответ: ____ м / Grid steps × 5',
            '   Шаги / Steps: __________________________________________'
          ]}
        ]
      },
      {
        title: 'Слой 2. Русский язык и правописание — слова помощи / Layer 2. Russian Language and Spelling — Help Words',
        blocks: [
          { type: 'text', text: 'Правило дня: безударные гласные проверяем ударением; «адрес» и «оператор» — запоминаем. / Rule: check unstressed vowels; "адрес"/"оператор" — memorise.' },
          { type: 'list', items: [
            'Словарь миссии: экстренная ситуация, помощь, адрес, телефон, оператор, пожар, потерялся, безопасное место, встреча, план. / Mission vocabulary.',
            'Мини-диктант: «В экстренной ситуации важно сказать, где ты находишься, и попросить помощь. Личные данные записывают только с родителем.» / Mini-dictation.',
            'Запиши без ошибок: __________________________________________ / Write without mistakes:',
            'Исправление: «в экстреной ситуации важна сказат где ты находишся и пасросить помощь. личные даные записываит толька с радителем.» / Correct and rewrite the sentence with mistakes.',
            'Подчеркни проверяемые гласные: помощь, телефон, план, место. / Underline checked vowels.'
          ]}
        ]
      },
      {
        title: 'Слой 3. Чтение, письмо и пересказ — что сказать / Layer 3. Reading, Writing and Retelling — What To Say',
        blocks: [
          { type: 'text', text: 'Прочитай короткий текст и сделай план. / Read the short text and make a plan.' },
          { type: 'list', items: [
            'Текст: «В экстренной ситуации скажи имя (если нужно), где ты, что случилось, и слушай взрослого или оператора. Никогда не звони 911 ради игры. Личные данные пиши только на бумаге с родителем.» / Text.',
            'План: 1) ____________________  2) ____________________  3) ____________________ / Plan',
            'Главная мысль: ______________________________________ / Main idea',
            'Мои 3–5 предложений «Что я скажу, если мне нужна помощь?»: / My 3–5 sentences',
            '1. ______________________________________________',
            '2. ______________________________________________',
            '3. ______________________________________________',
            '☐ Я пересказал родителю / I retold a parent.'
          ]}
        ]
      },
      {
        title: 'Слой 4. Наблюдение и логика — что делать первым / Layer 4. Observation and Logic — What To Do First',
        blocks: [
          { type: 'text', text: 'Понаблюдай: первое действие задаёт всю цепочку. / Observe: the first action sets the whole chain.' },
          { type: 'list', items: [
            'Что важно сделать первым? ____________________ / First action',
            'Что меняется, если я просто паникую? ____________________ / What changes if I panic?',
            'Что остаётся одинаковым в плане каждый раз? ____________________ / What stays the same?',
            'Где можно ждать помощь? ____________________ / Where can I wait?',
            'Что я говорю по телефону, если 911? ____________________ / What do I say on a 911 call?',
            'Мой вывод (1 фраза): ____________________ / My conclusion (1 line):'
          ]}
        ]
      },
      {
        title: 'Слой 5. Практика на бумаге — карточка помощи / Layer 5. Paper Practice — Help Card',
        blocks: [
          { type: 'text', text: 'ВАЖНО: настоящие данные пишем ТОЛЬКО на бумаге и ТОЛЬКО с родителем. В онлайн-задания не вводим адрес и телефон. / IMPORTANT: real data goes ONLY on paper and ONLY with a parent. Do NOT enter address or phone in online tasks.' },
          { type: 'list', items: [
            '[Вырежи карточку помощи и носи её с собой] / [Cut out the Help Card and keep it with you]',
            'Имя: ____________________ / Name',
            'Имя родителя: ____________________ / Parent name',
            'Телефон родителя: ____________________ / Parent phone',
            'Запасной взрослый: ____________________ / Backup adult',
            'Телефон запасного взрослого: ____________________ / Backup phone',
            'Безопасное место рядом с домом: ____________________ / Safe place near home',
            'Безопасное место рядом со школой: ____________________ / Safe place near school',
            'Семейное место встречи: ____________________ / Family meeting place',
            'Адрес дома (только с родителем): ____________________ / Home address (with parent)',
            'Что я говорю в экстренной ситуации (3 фразы): / What I say in an emergency:',
            '☐ "My name is..."',
            '☐ "I am at..."',
            '☐ "I need help."',
            '☐ "This is an emergency."',
            '☐ "Please call my parent."',
            '☐ "I am lost."',
            '5 шагов плана: / 5-step plan:',
            '1) Стоп, дыши. / Stop, breathe.',
            '2) Найди безопасного взрослого. / Find a safe adult.',
            '3) Скажи, где ты. / Say where you are.',
            '4) Если реально экстренно — 911. / If a real emergency — 911.',
            '5) Слушай и оставайся в безопасном месте. / Listen and stay in a safe place.',
            '[Поставь печать миссии] / [Place mission stamp]'
          ]}
        ]
      },
      {
        title: 'Дневник мышления / Thinking Diary',
        blocks: [
          { type: 'list', items: [
            'Моя уверенная фраза помощи: ______________________ / My confident help phrase',
            'Я выбрал её, потому что _________________________ / I chose it because',
            'Слово миссии, которое запомнилось: ________________ / Mission word I remember'
          ]}
        ]
      },
      {
        title: 'Родительская проверка и награда нимами / Parent Check and Nim Reward',
        blocks: [
          { type: 'text', text: 'После проверки начисли бонусные нимы через Parent Room. / After checking, add bonus nims through Parent Room.' },
          { type: 'list', items: [
            'Базовая награда: 3 нима ☐ / Base reward: 3 nims ☐',
            'Бонус за понятный план помощи: +1 ☐ / Help-plan bonus: +1 ☐',
            'Бонус за уверенную фразу помощи: +1 ☐ / Emergency-phrase bonus: +1 ☐',
            'Итого: ____ из 5 нимов. / Total ____ of 5 nims.',
            'Печать миссии (родитель): ☐ / Mission stamp (parent): ☐',
            'Подпись родителя: ____________________ / Parent signature'
          ]}
        ]
      }
    ]
  },
  parentGuide: {
    goal:
      'Ребёнок отрабатывает короткий, ясный план помощи (стоп / дыши / взрослый / 911 если экстренно / скажи где ты) и заполняет бумажную карточку помощи. Без драмы, спокойно. / Child rehearses a short clear help plan and fills a paper Help Card. Calm, not dramatic.',
    mathGoal:
      'Уровень 5–6 класса: масштаб (3.5 × 20); деление для нахождения времени (180 ÷ 60); сложение десятичных (0.5 + 1.25 + 2 + 0.75); координаты + масштаб (13 клеток × 5 м). / Grade 5–6: scale; division for time; decimal addition; coordinates + scale.',
    russianGoal:
      'Безударные гласные; «адрес» и «оператор» как словарные; правильно записанный мини-диктант; исправлены 3–5 предложений. / Unstressed vowels; address/operator as dictionary words; mini-dictation OK; sentences corrected.',
    readingWritingGoal:
      'План из 3 пунктов; пересказ родителю; 3–5 предложений на русском. / 3-point plan; retell; 3–5 Russian sentences.',
    observationLogicGoal:
      'Ребёнок может назвать первый шаг (стоп/дыши) и понимает, что план одинаковый, а ситуации могут отличаться. / Child names the first step and knows the plan is the same while situations may differ.',
    practicalGoal:
      'Бумажная карточка помощи заполнена с родителем; знание имени родителя/телефона/места встречи проверено устно. / Paper Help Card filled with the parent; name/phone/meeting place checked orally.',
    check: [
      'Q1: 70 м (3.5 × 20). Q2: 3 мин (180 ÷ 60). Q3: 4.5 мин (0.5+1.25+2+0.75). Q4: 65 м (13 клеток × 5). / Math answers.',
      'Мини-диктант записан без грубых ошибок. / Mini-dictation OK.',
      'План текста — 3 пункта; пересказ — 3–5 предложений по-русски. / Plan = 3 points; retell.',
      'Карточки разложены: «экстренная / не экстренная / спросить взрослого». / Cards sorted into 3 baskets.',
      'Бумажная карточка помощи заполнена с родителем (не онлайн). / Paper Help Card filled with the parent (not online).',
      'Дневник мышления заполнен. / Thinking diary filled.'
    ],
    answerKey: [
      { taskId: 'q1', answer: 'Answer: 70 метров. Solution: масштаб 1 см = 20 м; 3.5 × 20 = 70. Parent note: длина на карте × значение масштаба = реальное расстояние. / Grade 5–6: scale.' },
      { taskId: 'q2', answer: 'Answer: 3 минуты. Solution: время = расстояние ÷ скорость; 180 ÷ 60 = 3. Parent note: связь скорости, времени и расстояния — три «уголка треугольника». / Grade 5–6: distance ÷ speed = time.' },
      { taskId: 'q3', answer: 'Answer: 4.5 минуты. Solution: 0.5 + 1.25 + 2 + 0.75 = 4.5 (удобная группировка: 0.5 + 0.75 = 1.25; 1.25 + 1.25 = 2.5; 2.5 + 2 = 4.5). Parent note: десятичные удобно группировать парами по 0.25/0.5/0.75. / Grade 5–6: decimal addition, grouping.' },
      { taskId: 'q4', answer: 'Answer: 65 метров. Solution: (2,7)→(8,7) = 6 клеток; (8,7)→(8,3) = 4 клетки; (8,3)→(11,3) = 3 клетки; всего 6 + 4 + 3 = 13 клеток; 13 × 5 = 65 м. Parent note: координаты на сетке + перевод клетки в метры. / Grade 5–6: grid distance + scale.' },
      { taskId: 'q5', answer: 'Answer: помощь — о (помощник); телефон — е (телефонный); адрес — а (словарное, запомнить); план — а (плановый); место — е (место); оператор — о (запомнить, словарное). Solution: проверяемые — родственным словом с ударением; словарные — запоминаем. Parent note: «адрес» и «оператор» — слова, которые ребёнок будет писать в карточке помощи, важно знать их написание. / Vowels + dictionary words.' },
      { taskId: 'q6', answer: 'Answer: «В экстренной ситуации важно сказать, где ты находишься, и попросить помощь. Личные данные записывают только с родителем.» Solution: запятая после «находишься», точки. Parent note: ≤ 2 ошибок — нормально. / Mini-dictation: ≤ 2 errors acceptable.' },
      { taskId: 'q_corr', answer: 'Answer: «В экстренной ситуации важно сказать, где ты находишься, и попросить помощь. Личные данные записывают только с родителем.» Solution: экстреной→экстренной (две «н»); важна→важно (наречие на -о); сказат→сказать (мягкий знак); находишся→находишься (мягкий знак); пасросить→попросить (приставка «по» + проверка «просит»); даные→данные (две «н»); записываит→записывают (1-е спряжение, окончание «-ют»); толька→только (наречие на -о); радителем→родителем (проверка: родители); первая «в» с маленькой → с заглавной. Parent note: ошибок много — разбирайте по одному; засчитывай ≥ 8/10. / Acceptance: ≥ 8/10.' },
      { taskId: 'q7', answer: 'Answer: 3-пунктовый план + 3–5 предложений. Solution: пример плана — 1) скажи имя и где ты; 2) скажи что случилось; 3) слушай взрослого/оператора. Parent note: ключевая мысль — короткие конкретные фразы, без лишних деталей в панике. / 3-point plan; short concrete phrases.' },
      { taskId: 'q_obs', answer: 'Answer: Первое — стоп/дыши (3 секунды). При панике — теряется время и фразы путаются. Одинаково: 3 шага — кто я / где я / что случилось. Безопасно ждать — рядом с входом магазина, у кассы, у школьного офиса. По телефону 911 (в России 102/103): фамилия имя, адрес/ориентир, что случилось, ждать ответа оператора. Solution: пример вывода — «Сначала стоп-дыши, потом 3 факта, потом слушаю». Parent note: личные данные обсуждайте устно и пишите на бумажную карточку, НЕ онлайн. / Stop → 3 facts → listen.' },
      { taskId: 'q8', answer: 'Answer: Экстренная (взрослый/911) — пожар или дым, сильно поранил руку, кому-то рядом плохо. Не экстренная (спокойно) — забыл домашку, поспорил с другом. Спросить взрослого — потерялся в магазине, не помню дорогу домой, чувствую себя странно и тревожно. Solution: экстренная = опасность сейчас; «спросить взрослого» = непонятно или не уверен; «не экстренная» = решается спокойно. Parent note: чувство тревоги допускает оба варианта — обсудите с ребёнком, когда это «спросить взрослого», а когда «срочно к взрослому». / Sortings; grey-zone discussion.' },
      { taskId: 'q9', answer: 'Answer: открытый ответ, 3–5 предложений. Solution: пример — «Если мне нужна срочная помощь, я скажу: «Помогите, мне нужен взрослый», найду безопасное место и расскажу что случилось. На английском: "I need help". Личные данные я не пишу онлайн.» Parent note: критерии — фраза на русском, имя взрослого, английская фраза, НЕТ личных данных. / Open answer; no PII.' }
    ],
    spellingCheck:
      'Принимать, если правильно подобраны проверочные хотя бы для 3 из 6 слов и мини-диктант с не более чем 2 ошибками. / Accept ≥ 3/6 vowels and ≤ 2 mistakes.',
    readingCheck:
      'План — 3 пункта; пересказ по-русски без чтения с листа. / 3-point plan; retell in Russian without reading.',
    practicalCheck:
      'Бумажная карточка помощи заполнена ВМЕСТЕ с родителем. Личные данные НЕ вводятся в онлайн-задания. Ребёнок устно называет имя родителя, телефон и место встречи. / Paper Help Card filled WITH the parent. No PII online. Child names parent/phone/meeting place orally.',
    rolePlayCheck:
      'Родитель проигрывает 1–2 короткие сценки (потерялся в магазине / упал и поранился). Ребёнок отвечает: «My name is..., I am at..., I need help.» Спокойно. / Parent role-plays 1–2 scenes; child responds calmly with the phrase.',
    discussionPrompts: [
      'Что такое «экстренная ситуация»? / What is an emergency?',
      'Когда нужно звонить 911, а когда нет? / When do we call 911 and when not?',
      'Где наше семейное место встречи? / Where is our family meeting place?',
      'Что важно сказать первым? / What is most important to say first?'
    ],
    ifEasy:
      'Усложни: попроси перечислить 3 разных безопасных места рядом с домом и школой и обосновать. / Add 3 safe places near home and school with reasoning.',
    ifDifficult:
      'Возьми 1 простую сценку (потерялся в магазине). Помоги повторить 3 фразы: «My name is...», «I need help.», «Please call my parent.» / Use 1 simple scene; help repeat 3 phrases.',
    commonMistakes: [
      'Ребёнок «застывает» и ничего не делает. Подсказка: первый шаг — стоп/дыши/найти взрослого. / Child freezes — first step is stop/breathe/find an adult.',
      'Ребёнок думает, что 911 — это для игры. Уточни: 911 — только для реальной экстренной ситуации. / Child thinks 911 is for games — clarify it is for real emergencies.'
    ],
    parentNote:
      'Тренируйте спокойно, без драматизации. Главное — короткие повторяемые шаги. / Practise calmly, without drama. Key is short repeatable steps.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / After checking the work, the parent may add bonus nims through Parent Room. Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim',
    unitName: 'ним',
    base: 3,
    max: 5,
    label: 'Награда за миссию',
    display: '3 нима',
    bonuses: [
      { id: 'help-plan', label: 'Бонус за понятный план помощи', amount: 1 },
      { id: 'emergency-phrase', label: 'Бонус за уверенную фразу помощи', amount: 1 }
    ]
  },
  completionRequirements: {
    requiredTaskIds: ['q1', 'q5', 'q7', 'q8', 'q9'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'max-week-2-day-5'
};

export default day4;
